import { cn } from '~/utils/cn'

import { Button } from '~/components/button'

import { headingStyles, rootStyles } from './product-header.styles'

import type {
  BaseProps,
  ProductHeaderDesktopConfig,
  ProductHeaderMobileConfig,
} from './product-header.types'

export type ProductHeaderRootProps = BaseProps &
  (ProductHeaderDesktopConfig | ProductHeaderMobileConfig)

export function ProductHeaderRoot({
  variant,
  heading,
  headingAs: Heading = 'h4',
  children,
  actions,
}: ProductHeaderRootProps) {
  const isMobile = variant === 'mobile'

  return (
    <header className={cn(rootStyles())}>
      <Heading className={cn(headingStyles())}>{heading}</Heading>

      <div className="flex items-center gap-x-[var(--spacing-inline-threepulse)]">
        <div className="flex-1 overflow-hidden">{children}</div>

        {isMobile && actions && (
          <div className="inline-flex items-center gap-x-[var(--spacing-inline-threepulse)]">
            {actions.map(({ id, icon, ...buttonProps }) => (
              <Button.Root
                key={id}
                variant="neutral-secondary"
                {...buttonProps}
              >
                <Button.Icon symbol={icon} />
              </Button.Root>
            ))}
          </div>
        )}
      </div>
    </header>
  )
}
